var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.components.addToCartOnProductPage,{tag:"component",attrs:{"domAdd2CartSelector":_vm.config.tracking.addToCart.buttonsSelector}})}
var staticRenderFns = []

export { render, staticRenderFns }